<template>
  <div class="user">
    <div class="clearfix about">
      <div class="pull-left avatar">
        <template v-if="enterpriseDefault.ID">
          <img v-if="enterpriseDefault.Logo"
            :src="`${enterpriseDefault.Logo}?imageView2/1/w/48/h/48`"
          />
          <img v-else src="./images/avatar.png" />
        </template>
        <img v-else-if="userInfo.image" :src="`${userInfo.image}?imageView2/1/w/48/h/48`" />
        <img v-else src="./images/avatar.png" />
      </div>
      <div class="pull-left text">
        <!--<div>欢迎来到{{enterpriseInfo.titleCh || enterpriseInfo.titleEn}}</div>-->
        <div>欢迎来到{{enterpriseInfo.platformName}}</div>
        <div v-if="userInfo.id">
          {{
            enterpriseDefault.ID ? enterpriseDefault.Name :
            (userInfo.realName || userInfo.loginName)
          }}
          <span class="logout">[<a :href="logout">退出</a>]</span>
        </div>
        <ul v-else class="ul-cls clearfix fn">
          <li><a :href="loginUrl">请登录</a></li>
          <li><a v-if="enterpriseInfo.openRegistry" href="/register" class="reg">免费注册</a></li>
        </ul>
      </div>
    </div>
    <div class="text-center control">
      <a :href="loginUrl" v-if="!userInfo.id">
        <svg-icon icon-name="seller" />个人中心
      </a>
      <a href="/personal" target="_blank" v-else>
        <svg-icon icon-name="seller" />个人中心
      </a>
      <a  :href="loginUrl" v-if="!userInfo.id">
        <el-badge :hidden="orderNum === 0" :max="99" type="primary" :value="orderNum">
          <svg-icon icon-name="order" />我的订单
        </el-badge>
      </a>
      <a href="/manage?type=0" v-else>
        <el-badge :hidden="orderNum === 0" :max="99" type="primary" :value="orderNum">
          <svg-icon icon-name="order" />我的订单
        </el-badge>
      </a>
      <a :href="loginUrl" v-if="!userInfo.id">
        <svg-icon icon-name="favorite" />专属货品
      </a>
      <a v-else @click="gotorecommend">
        <!--:href="`${sc}recommend/page.do?yynid=1`" target="_blank"-->
        <svg-icon icon-name="favorite" />专属货品
      </a>
    </div>
    <div class="news">
      <div class="clearfix title">
       <span>行业</span>
        <span class="topline">头条</span>
      </div>
      <ul class="ul-cls list">
        <template v-for="(item, index) in newsList">
          <li :key="item.id" v-if="index < 3">
            <router-link :to="`/news?id=${item.id}`" target="_blank">
              {{item.name}}
            </router-link>
          </li>
        </template>

      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loginUrl: `/login?retUrl=${window.location.href}`,
      sc: process.env.VUE_APP_SC,
      reg: `${process.env.VUE_APP_PASSPORT}register/user`,
      enter: `${process.env.VUE_APP_CAS}cas/login.html?service=${process.env.VUE_APP_WO}&systemId=12&retUrl=${window.location.href}`,
      logout: `${process.env.VUE_APP_CAS}cas/logout?service=${window.location.href}`,
      newsList: [],
      orderNum: 0,
      personalUrl: '',
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo,
    portalDomain: state => state.app.portalDomain,
    enterpriseInfo: state => state.app.enterpriseInfo,
    enterpriseDefault: state => state.app.enterpriseDefault,
  }),
  created() {
    if (this.userInfo.id) {
      this.personalUrl = '/personal';
    } else {
      this.personalUrl = this.loginUrl;
    }
    const arg = {};
    const orgId = this.enterpriseDefault.ID;
    if (orgId) {
      arg.orgId = orgId;
    }

    arg.platformtype = this.portalDomain.platType;
    // 我的订单
    this.$store.dispatch('index/getOrderNums', arg).then((data) => {
      if (data) {
        const {
          // 待支付
          dzfOrderNum,
          // 待发货
          orderStatus2,
          // 待收货
          orderStatus3,
        } = data;
        this.orderNum = (dzfOrderNum || 0) + (orderStatus2 || 0) + (orderStatus3 || 0);
      }
    });

    // 企业头条
    this.$store.dispatch('news/getList', {
      id: this.portalDomain.enterpriseId,
    }).then((data) => {
      this.newsList = data;
    });
  },
  methods: {
    // 跳转专属货品
    gotorecommend() {
      const startTime = this.tranDate('2019-12-29 22:00');
      // 结束时间
      const endTime = this.tranDate('2020-1-1 00:00');
      const thisDate = new Date();
      // 获取当前时间，格式为 2018-9-10 20:08
      const currentTime = `${thisDate.getFullYear()}-${thisDate.getMonth() + 1}-${thisDate.getDate()} ${thisDate.getHours()}:${thisDate.getMinutes()}`;
      const nowTime = this.tranDate(currentTime);
      // 如果当前时间处于时间段内，则提示文案
      if (nowTime > startTime && nowTime < endTime) {
        this.$msgbox('12月29日晚10点至1月1日0点，养易纽订货系统维护，请稍后操作。', '提示', {
          confirmButtonText: '确定',
        });
      } else {
        this.$router.push('/order');
        // window.open(`${this.sc}recommend/page.do?yynid=${this.portalDomain.platType}`, '_blank');
      }
    },
    tranDate(time) {
      return new Date(time.replace(/-/g, '/')).getTime();
    },
  },
};
</script>
